import React from 'react'
import { Revelations } from './Revelations'
import './Revelations.scss'

export const RevelationsPage = () => {
    return (
        <div className='revelations-page'>
            <Revelations fullScreen={true} />
        </div>
    )
}
